/** 
 * creater for model
 */
import throwError from './util/throwError'; 
import {addActions} from './actions';

const isObject = target => Object.prototype.toString.call(target) === '[object Object]';
export const models = [];
const SEP = "/";

export default function model(obj){
  const {name,reducers,initialState,effects} = validateModel(obj);
  //deal reducers
  const reducer = getReducer(resolveReducers(name, reducers), initialState);
  //Add action Automatically  action name depend on reducers name
  addActions(name, reducers,effects);
  
  const toAdd = {name,reducer};
  models.push(toAdd);
  
  return toAdd;
}


function validateModel(obj){
    const {name,reducers,effect} = obj;

    if(!name || typeof name !== 'string'){
        throwError('Miss model name or name is not a valid string');
    }

    if (name === 'routing') {
        //目前没有用到react-router-redux 但是为了后续预留
        throwError(`Model name can not be "routing", it is used by react-router-redux!`);
    }

    if(models.some(item => item.name === name)){
        throwError(`name ${name} has exist`);
    }

    if(reducers!==undefined && !isObject(reducers)){

        throwError(`Model reducers must be a valid object`);
    }

    if(effect!==undefined && !isObject(effect)){

        throwError(`Model effect must be a valid object`);
    }
    //Filter out non-function entries
    obj.reducers = filterReducers(reducers);
    return obj;

}
/**
 * Filter out non-function entries
 * @param {*} reducers 
 */
function filterReducers(reducers){
    if (!reducers) {
        return reducers
    }

    return Object.keys(reducers)
    .reduce((acc, action) => {
        // Filter out non-function entries
        if (typeof reducers[action] === 'function') {
        acc[action] = reducers[action]
        }
        return acc
    }, {})

}
/**
 * 
 * @param {*} modelName 
 * @param {*} reducers 
 */
function resolveReducers(modelName, reducers = {}) {
    return Object.keys(reducers).reduce((acc, cur) => {
      acc[`${modelName}${SEP}${cur}`] = reducers[cur]
      return acc
    }, {})
}
//action {type:"",data:""}
/**
 * 
 * @param {*} reducers 
 * @param {*} initialState 
 */
function getReducer(reducers, initialState = null){
    return (state = initialState,action) =>{
        if(typeof reducers[action.type] === "function"){
            return reducers[action.type](state,action.data);
        }
        return state;
    }
}


